const reducer = (prevState, newState) => {
	if (typeof newState === 'object') return { ...prevState, ...newState };
	if (typeof newState === 'function') return newState(prevState);
	return false;
};
export { reducer };
